import 'whatwg-fetch';
import { useState, useCallback, useEffect } from 'react';

export const fetchPosts = async (route) => {
   const response = await fetch(route);
   return response.json();
};

/**
 * Handle post fetching and refreshing
 *
 * @param {string} route - route to fetch objects from
 * @param {array} initialPosts - initial array of posts passed to component
 */
export default function usePosts(props) {
   const { route } = props;
   const [posts, setPosts] = useState(props.posts || []);
   // refresh callback
   const refreshData = useCallback(() => {
      fetchPosts(route)
         .then(res => setPosts(res));
   }, [route]);
   // refresh on load (if no posts delivered)
   useEffect(() => {
      if ((!props.posts || !props.posts.length) && route) {
         console.log('No posts delivered with props, fetching data');
         refreshData();
      }
      else {
         setPosts(props.posts);
      }
   }, [route]);
   // deliver back to component
   return { posts, refreshData };
}
